function nunjucks_filter_nl2br()
{
    this.isAsync = false;
    this.name = 'nl2br';
    this.filter = function(str)
    {
        if (typeof str === 'string') {
            return str.replace('\r\n', '<br>').replace('\n', '<br>');
        } else {
            return str;
        }
    };
}
